export abstract class ToggleableAttribute {
  value: string | boolean = '';
  isAttached = false;

  attached() {
    if (this.isEnabled)
      this.enabled();
    this.isAttached = true;
  }

  detached() {
    this.isAttached = false;
    if (this.isEnabled)
      this.disabled();
  }

  valueChanged() {
    if (this.isAttached)
      this.isEnabled ? this.enabled() : this.disabled();
  }

  get isEnabled() {
    return this.value === '' || this.value && this.value !== 'false' ? true : false;
  }

  protected abstract enabled(): void;
  protected abstract disabled(): void;
}
